
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },
  head() {
    return {
      title: "Les 10 meilleures pratiques pour un maillage interne efficace",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un maillage interne bien structuré améliore le SEO et l’expérience utilisateur. Découvrez 10 bonnes pratiques pour optimiser vos liens internes avec ALEO.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Les 10 meilleures pratiques pour un maillage interne efficace",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un maillage interne bien structuré améliore le SEO et l’expérience utilisateur. Découvrez 10 bonnes pratiques pour optimiser vos liens internes avec ALEO.",
        },
      ],
    };
  },
};
